import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Button, Text } from '@carnica/ui-kit';
import { MenuUrlTarget } from "../../../../../../../../types";
export var CategoriesItem = function CategoriesItem(_ref) {
  var category = _ref.category,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("li", {
    key: category.title
  }, /*#__PURE__*/React.createElement(Button, _extends({
    mode: "inline"
  }, category.url ? {
    href: category.url,
    tagName: 'a',
    target: MenuUrlTarget.get(category.isBlankUrlTarget)
  } : {
    onClick: function onClick() {
      return _onClick(category);
    }
  }), /*#__PURE__*/React.createElement(Text, {
    color: "primary-invert"
  }, category.title)));
};